import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import styled from "styled-components/macro";

export default function DevBoxInternalNote({ slug }: { slug: string }): JSX.Element {
    if (slug !== "devboxinternal") {
        return null;
    }
    return (<Wrapper aria-label="DevBox (Internal) Information">
        <p> <b>Please note before reporting!</b></p>
        <p>
            <ul>
                <li>Only report bugs or feature suggestions on this page, reviewed bi-weekly by engineers.</li>
                <li><b>If you&#39;re blocked, see troubleshooting guidance</b> at <a href="https://eng.ms/docs/cloud-ai-platform/devdiv/one-engineering-system-1es/1es-docs/dev-box/faq" target="_blank" rel="noreferrer">Dev Box FAQs | 1ES On EngHub</a></li>
                <li><b>For immediate support</b> on blocking issues contact <a href="https://microsoft.sharepoint.com/sites/TechWeb" target="_blank" rel="noreferrer">Techweb</a></li>
            </ul>
        </p>
    </Wrapper>);
}

const Wrapper = styled.div`
    padding: 2rem;
    margin: 2rem 0;
    border: 0.1rem solid var(--color-info);
    border-top: 0.4rem solid var(--color-info);
    border-radius: 0.2rem;
    box-shadow: 0px 0.3px 0.9px rgb(0 0 0 / 11%),0px 1.6px 3.6px rgb(0 0 0 / 13%);
    background-color: var(--color-surface);

    ul {
        padding-inline-start: 4rem;
        margin-block-start: 1em;
        margin-block-end: 1em;

        li {
            display: list-item;
        }
    }
`;
